module.exports = __webpack_public_path__ + "static/carousel-background-0f5aa0c47dc158a4382af45527f75fe7.jpg";